/**
 * @ngdoc Controller
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .controller('ConfirmFieldController', ConfirmFieldController);

    /* @ngInject */
    function ConfirmFieldController($scope, close, action, options, callback, title, description, extraClass) {
        $scope.inputValue = "";
        $scope.checkboxValue = false;
        $scope.action = action;
        $scope.title = title;
        $scope.checkboxUsed = !!options.checkboxVersion;
        $scope.extraClass = extraClass || '';
        $scope.description = description;
        $scope.expected = (options.expectedFieldValue || "").toString().toLowerCase().trim();

        const inputEl = document.getElementById('confirmationField');
        angular.element(inputEl).focus();
        $scope.confirm = function () {
            if (!$scope.confirmForm.$valid) return;
            if (!$scope.checkboxUsed && $scope.inputValue.toLowerCase().trim() !== $scope.expected) return;
            if ($scope.checkboxUsed && !$scope.checkboxValue) return;
            $.magnificPopup.close();
            callback(true);
        };

        return {
            close: close
        };
    }

})();
